import { m, AnimatePresence, useReducedMotion } from 'framer-motion';

import Box from '@mui/material/Box';

import { usePathname } from 'src/routes/hooks';

// ----------------------------------------------------------------------

const TRANSITION = {
  duration: 0.28,
  ease: [0.4, 0, 0.2, 1],
};

/**
 * Wraps route content with a fade-and-rise keyed on the current pathname.
 * Skips animation when the user prefers reduced motion.
 */
export function PageTransition({ children, ...other }) {
  const pathname = usePathname();
  const reduceMotion = useReducedMotion();

  if (reduceMotion) {
    return <Box {...other}>{children}</Box>;
  }

  return (
    <AnimatePresence mode="wait" initial={false}>
      <Box
        key={pathname}
        component={m.div}
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0, transition: TRANSITION }}
        exit={{ opacity: 0, transition: { ...TRANSITION, duration: 0.16 } }}
        sx={{ display: 'flex', flex: '1 1 auto', flexDirection: 'column' }}
        {...other}
      >
        {children}
      </Box>
    </AnimatePresence>
  );
}
